import React, {useState, useEffect} from 'react';
import Select, { components } from 'react-select';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import {
  Button,
  Card,
  CardGroup,
  Col,
  Container,
  Form,
  InputGroup,
  Row
} from 'react-bootstrap';
import '../../assets/css/pages/form.css';
import { alertResponseMessage } from "../../actions/action-creators/response";
import {LoaderMedium} from './../../components/loader';
import ValidationHelper from '../../helper/validation';
//Axios Call
import {error_api_call, get_api_call, post_api_call} from '../../actions/action-creators/common';
import {SetMetaData} from './../../helper/page-title';
import {RSNoRadiusStyle, RSRegisterStyle, RSRegErrStyle, RSNoRadiusErrStyle, RSRegisterMultiStyle} from "../../config/react-select";

const inputDefaultValue = {
  first_name: '',
  last_name: '',
  email: '',
  phone_code_id: '',
  mobile: '',
  country_id: '',
  state_id: '',
  city_name: '',
  pan_number: '',
  gst_number: '',
  affiliate_type_id: '',
  affiliate_type: '',
  website: '',
  social_handle: '',
  follower_count: '',
  reach_count: '',
  marketing_plan_id: '',
  marketing_plan: '',
  marketing_plan_show: false,
  is_prev_promoted: '',
  product_name: '',
  monthly_target_id: '',
  holder_name: '',
  acc_number: '',
  ifsc_code: '',
  upi_id: '',
  check_1: '',
  check_2: '',
  check_3: '',
  check_4: '',
};
// const inputDefaultValue = {
//   first_name: 'Riti',
//   last_name: '',
//   email: 'riti@riti.com',
//   phone_code_id: {id: 101, phone_code: '91'},
//   mobile: '9804018840',
//   country_id: {id: 101,name: "India"},
//   state_id: {id: 1, state: "West Bengal"},
//   city_name: 'Kolkata',
//   pan_number: '',
//   gst_number: '',
//   affiliate_type_id: {id: 1, label: "Social Media Influencer"},
//   affiliate_type: '',
//   website: '',
//   social_handle: '@ritika',
//   follower_count: '',
//   reach_count: {id: 7, label: "<100"},
//   marketing_plan_id: [{id: 11, label: "YouTube reviews/tutorials"}, {id: 12, label: "Instagram / TikTok / Facebook reels"}],
//   marketing_plan: '',
//   marketing_plan_show: false,
//   is_prev_promoted: {id: 1, label: "Yes"},
//   product_name: 'Test Pro',
//   monthly_target_id: {id: 18, label: "<50>"},
//   holder_name: 'Ritika',
//   acc_number: '123456',
//   ifsc_code: 'A123',
//   upi_id: '@riti123',
//   check_1: '',
//   check_2: '',
//   check_3: '',
//   check_4: '',
// };
var validatorData = {//To Show error box
  first_name: 'required|max:50',
  last_name: 'optional|max:50',
  email: 'required|email|max:150',
  phone_code_id: 'required||STD Code/Mobile Number code',
  mobile: 'required|digit:|min:6|max:15||WhatsApp Number',
  country_id: 'required||Country',
  city_name: 'required|max:100||City/Town',
  state_id: 'optional||State',
  pan_number: 'optional|min:10|max:10||PAN Number',
  gst_number: 'optional|min:15|max:15||GST Number',
  affiliate_type_id: 'required||Affiliate Type',
  affiliate_type: 'optional|max:150||Affiliate Type',
  website: 'optional|max:250||Website/Blog URL',
  social_handle: 'required|max:250||Social Media Handles',
  follower_count: 'optional|digit:|min:0|max:1000000000||Follower / Subscriber Count',
  reach_count: 'required||Average Monthly Student Reach',
  marketing_plan_id: 'required||Your Marketing Plans',
  marketing_plan: 'optional|max:150||Your Marketing Plans',
  is_prev_promoted: 'required||Have you promoted digital products before?',
  product_name: 'optional|max:250||Promoted digital products, which ones?',
  monthly_target_id: 'required||What is your monthly target with PORT?',
  holder_name: 'optional|max:250||Bank Account Holder Name',
  acc_number: 'optional|max:250||Bank Account Number',
  ifsc_code: 'optional|max:11||IFSC Code',
  upi_id: 'optional|max:250||UPI ID',
  check_1: 'checkbox_req||Checkbox No. 1: Tick checkbox to confirm',
  check_2: 'checkbox_req||Checkbox No. 2: Tick checkbox to confirm',
  check_3: 'checkbox_req||Checkbox No. 3: Tick checkbox to confirm',
  check_4: 'checkbox_req||Checkbox No. 4: Tick checkbox to confirm',
};

const AffiliateForm = () => {
  SetMetaData("Affiliate-Apply", "", "");
  // const navigate = useNavigate();
  const { ValueContainer, Placeholder } = components;
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [dataDropdown, setDataDropdown] = useState({type: [], monthly_reach: [], marketing_plan: [], monthly_target: [], prev_promoted: []});
  const [inputFields, setFields] = useState(inputDefaultValue);
  // const [submitDisabled, setSubmitDisabled] = useState(true);
  const [isApplyProcess, setIsProcess] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [validCheckData, setValidCheck] = useState({first_name: true,
                                                    last_name: true,
                                                    email: true,
                                                    phone_code_id: true,
                                                    mobile: true,
                                                    country_id: true,
                                                    state_id: true,
                                                    city_name: true,
                                                    pan_number: true,
                                                    gst_number: true,
                                                    affiliate_type_id: true,
                                                    affiliate_type: true,
                                                    website: true,
                                                    social_handle: true,
                                                    follower_count: true,
                                                    reach_count: true,
                                                    marketing_plan_id: true,
                                                    marketing_plan: true,
                                                    is_prev_promoted: true,
                                                    product_name: true,
                                                    monthly_target_id: true,
                                                    holder_name: true,
                                                    acc_number: true,
                                                    ifsc_code: true,
                                                    upi_id: true,
                                                    check_1: true,
                                                    check_2: true,
                                                    check_3: true,
                                                    check_4: true,
                                                  });
  //Get Data from APIs
  const fetchSelectList = async(url, data={}) => {
    try{
      const apiUrl = (url === 'schools')
                    ? `${url}?fetch_type=is_glosco`
                    : url;
      const selectApiData = await get_api_call(apiUrl, data);
      if(selectApiData.status === 200){
        switch (url) {
          case 'countries':
            setCountryData(selectApiData.data);
            break;
          case 'states':
            setStateData(selectApiData.data);
            break;
          case 'affiliate/options/affiliate-master':
            data = selectApiData.data;
            setDataDropdown({type: [...data.type],
                            monthly_reach: [...data.monthly_reach],
                            monthly_target: [...data.monthly_target],
                            prev_promoted: [...data.prev_promoted],
                            marketing_plan: [...data.marketing_plan]});
            break;
          default: 
        }
      }
    }catch(e){
      error_api_call({error: `screens|affiliate|form|fetchSelectList|${e}`});
    }
  }
  //Redirection Url
  useEffect(() => {
    fetchSelectList('countries');
    fetchSelectList('states');
    fetchSelectList('affiliate/options/affiliate-master');
  }, []);// eslint-disable-line react-hooks/exhaustive-deps
  //Update Input Box
  const _onChangeText = (attrName, value, type='') => {
    try{
      setErrorData([]);
      let fields = {...inputFields};
      if(attrName === 'mobile' 
        && value.length < 16
      ){
        value = value.replace(/[^0-9]/g, '');
        // fields[attrName] = value;
      }else if(attrName === 'last_name'
        || attrName === 'first_name'
      ){
        //Only letter & Space
        value = value.replace(/[^a-zA-Z. ]/g, '')
                    .replace('  ', ' ');
      }else if(attrName === 'email'){
        value = value.replace(/ /g, '');
      }else{
        if(type !== 'select'
          && type !== 'checkbox'
        ){
          // value = value.replace(/  /g, ' ');
          value = value.replace('  ', ' ');
        }
      }
      fields[attrName] = value;
      if(attrName === 'marketing_plan_id'){
        var planIds = [];
        value.forEach(plan => {
          planIds.push(plan.id);
        });
        if(planIds.includes(17)){
          fields['marketing_plan_id'] = [{id: 17, label: 'Other'}];
          fields['marketing_plan_show'] = true;
        }else{
          fields['marketing_plan_show'] = false;  
        }
      }
      setFields({...fields});
      //Validation Check
      if(typeof validatorData[attrName] !== "undefined"){
        const validation = ValidationHelper.validation(fields, {[attrName]: validatorData[attrName]}).error;
        setValidCheck({...validCheckData, [attrName]: validation.length ? false : true});
      }
    }catch(e){
      console.log(e)
      error_api_call({error: `screens/affiliate/form|_onChangeText|${JSON.stringify(inputFields)}|${e}`});
    }
  }
  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused} style={{marginBottom: 5}}>
          {props.selectProps.placeholder}
        </Placeholder>
        {/* <div className={`${child && child.type !== Placeholder ? 'select-float' : ''}`}> */}
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
        {/* </div> */}
      </ValueContainer>
    );
  };
  //Validation
  const _validate = () => {
    // if (!didMount) return null;
    let fields = {...inputFields};
    try{
      var validators = {...validatorData};
      if(fields.country_id
        && typeof fields.country_id.id !== "undefined"
        && fields.country_id.id === 101
      ){
        validators['state_id'] = 'required||State';
      }
      //Affiliate Type
      if(fields.affiliate_type_id
        && typeof fields.affiliate_type_id.id !== "undefined"
        && fields.affiliate_type_id.id === 6 //Other
      ){
        validators['affiliate_type'] = 'required|max:150||Affiliate Type';
      }
      //Marketing Plan
      if(fields.marketing_plan_id
        && fields.marketing_plan_id.length > 0
      ){
        var planIds = [];
        fields.marketing_plan_id.forEach(plan => {
          planIds.push(plan.id);
        });
        if(planIds.includes(17)){
          validators['marketing_plan'] = 'required|max:150||Your Marketing Plans';
        }
      }
      //Product Name
      if(fields.is_prev_promoted
        && typeof fields.is_prev_promoted.id !== "undefined"
        && fields.is_prev_promoted.id === 1
      ){
        validators['product_name'] = 'required|max:250||Promoted digital products, which ones?';
      }
      //Bank Details
      if(fields.upi_id === ''){
        validators['holder_name'] = 'required|max:250||Bank Account Holder Name';
        validators['acc_number'] = 'required|max:250||Bank Account Number';
        validators['ifsc_code'] = 'required|max:11||IFSC Code';
        validators['upi_id'] = 'optional|max:250||UPI ID';
      }else{
        validators['holder_name'] = 'optional|max:250||Bank Account Holder Name';
        validators['acc_number'] = 'optional|max:250||Bank Account Number';
        validators['ifsc_code'] = 'optional|max:11||IFSC Code';
        validators['upi_id'] = 'required|max:250||UPI ID';
      }
      //Loop through validator data
      var validCheck = {};
      var validation = [];
      for (var keyValid of Object.keys(validators)) {
        // console.log(key + " -> " + p[key])
        var validationCheck = ValidationHelper.validation(fields, {[keyValid]: validators[keyValid]}).error;
        validCheck[keyValid] = validationCheck.length ? false : true;
        if(validationCheck.length){
          validation.push(validationCheck[0]);
        }
      }
      setValidCheck({...validCheckData, ...validCheck});
      return validation;
    }catch(e){
      error_api_call({error: `screens/affiliate/form|_validate|${JSON.stringify(inputFields)}|${e}`});
    }
  };
  //Login-Register User
  const _applyAffiliate = async(e) => {
    //Validation:Already done
    //Show Loader
    try{
      e.preventDefault();
      const validCheck = _validate();
      if(validCheck.length){
        setErrorData([validCheck[0]]);
        return;
      }
      var formData = {...inputFields};
      formData.country_id = formData.country_id.id;
      formData.phone_code_id = formData.phone_code_id.id;
      formData.mobile = parseInt(formData.mobile);
      formData.affiliate_type_id = formData.affiliate_type_id.id;
      if(formData.affiliate_type_id.id === 6){
        formData.affiliate_type = formData.affiliate_type;
      }
      formData.reach_count = formData.reach_count.id;
      formData.is_prev_promoted = formData.is_prev_promoted.id;
      formData.monthly_target_id = formData.monthly_target_id.id;
      if(formData.country_id === 101
        && formData.state_id
      ){
        formData.state_id = formData.state_id.id;
      }else{
        formData.state_id = '';
      }
      if(formData.is_prev_promoted !== 1){
        formData.product_name = '';
      }
      
      if(formData.marketing_plan_id){
        var planIds = [];
        formData.marketing_plan_id.forEach(plan => {
          planIds.push(plan.id);
        });
        formData.marketing_plan_id = planIds;
        if(planIds.includes(17)){
          formData.marketing_plan = formData.marketing_plan;
        }
      }
      
      setIsProcess(true);
      setErrorData([]);
      
      const applyApiData = await post_api_call(`affiliate/apply`, formData);
      if(applyApiData.status === 200){
        setIsSuccess(true);
        // alertResponseMessage({alert_type: 1, message: "Submitted Successfully"});
        alertResponseMessage({alert_type: 1, message: applyApiData.message});
      }else{
        setErrorData([applyApiData.message]);
      }
      setIsProcess(false);   
    }catch(e){
      console.log(e)
      setErrorData(['Error Submitting In! Please Try Again']);
      setIsProcess(false);
      error_api_call({error: `screens/affiliate/form|_applyAffiliate|${JSON.stringify(inputFields)}|${e}`});
    }
  }

  return (
    <main id="main">
    <div className="c-app c-default-layout align-items-center custom-form login-form">
      <Container style={{minHeight: '66vh'}}>
        <Row className="justify-content-center mb-5">
          <Col md="8" lg="8">
            <Row>
            <Col md="12" lg="12">
            <CardGroup className="team-detail">
              <Card className="p-sm-2">
                <Card.Body>
                <form name="register" id="register">
                    <div className="section-header section-header-1">
                        <h1 className="mb-4 title">PORT Affiliate Program – Apply Now</h1>
                    </div>
                    {isSuccess
                    ?
                      <div className="alert alert-success text-center mb-0" role="alert">
                        <strong className="fs-1">Thank You!</strong>
                        <p className="mt-2 fs-5">Application Submitted Successfully! This submission constitutes your acceptance of our Affiliate MOU. To complete the process and sent the application for review, Please verify your Email. Click on the verification link sent to your Email.</p>
                      </div>
                    :
                      <>
                        <p className="mb-3 fw-bold" style={{fontSize: 18}}>Become a PORT Affiliate and Build the Future of Students – While Building Your Own Earnings</p>
                        <p>PORT is part of <b>IFSPD Europe</b>, one of the world’s largest international institutions with members from over 60 countries and <b>Special Consultative Status with the United Nations</b>.</p>
                        <div>
                          Why This Is a Unique Opportunity for You:
                          <ul>
                            <li><b>High Recurring Earnings</b> – Earn ₹1000 per student subscription (50% share) + ₹500 recurring income upon renewal every year. Typically our agents earn Rs.10 lacs monthly.</li>
                            <li><b>Big Market</b> – Millions of students in India and abroad preparing for higher education. PORT helps students showcase their achievements globally and get matched with their best-fit universities.</li>
                            <li><b>First-Mover Advantage</b> – PORT is a unique platform; affiliates who join early capture the strongest territories.</li>
                            <li><b>Easy Onboarding</b> – Simple signup, transparent tracking, fast pay-outs.</li>
                          </ul>
                        </div>
                        <p>If you are a <b>counsellor, coaching institute, influencer, blogger, educator, or student community leader</b>, this is your chance to grow with us.</p>
                        <Row>
                          <p className="text-end mb-1"><em>*</em> Indicates required info</p>
                          <b>Basic Information</b>
                          {/* First Name */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-user"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingFirst"
                              label="First Name"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="First Name*"
                                autoComplete="first-name" 
                                value={inputFields.first_name}
                                onChange={(event) => _onChangeText('first_name', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.first_name ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* <p className="input-info">Space Not Allowed,minimum 2 Characters</p> */}
                          {/* Last Name */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-user"></i>&nbsp;&nbsp;</InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Last Name"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Last Name"
                                autoComplete="last-name" 
                                value={inputFields.last_name}
                                onChange={(event) => _onChangeText('last_name', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.last_name ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* Email */}
                          <Col md="6">
                          <div  className="mb-3">
                          <InputGroup>
                              <InputGroup.Text><i className="fa fa-envelope"></i>&nbsp;<em>*</em></InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingEmail"
                                label="Email address"
                              >
                                <Form.Control 
                                  type="email" 
                                  placeholder="Email address*" 
                                  autoComplete="user_name" 
                                  value={inputFields.email}
                                  onChange={(event) => _onChangeText('email', event.target.value)}
                                  maxLength={150}
                                  //   readOnly={currentStep !== 1 || isApplyProcess ? true : false}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.email ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                          </InputGroup>
                          <p className="input-info">For all access and log in</p>
                          </div>
                          </Col>
                          {/* Mobile Number */}
                          <Col md="6">
                          <div  className="mb-3">
                          <InputGroup>
                            <InputGroup.Text><i className="fa fa-whatsapp"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="w-110p">
                            <Select
                                // isDisabled={true}
                                options={countryData}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                // defaultValue={inputFields.phone_code_id}
                                value={inputFields.phone_code_id}
                                placeholder={"Code"}
                                onChange={(value) => _onChangeText('phone_code_id', value, 'select')}
                                getOptionLabel ={(option) => `+${option.phone_code}`}
                                getOptionValue ={(option) => option.id}
                                // styles={RSNoRadiusStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                // classNamePrefix="reactCSel"
                                styles={!validCheckData.phone_code_id ? RSNoRadiusErrStyle : RSNoRadiusStyle}
                            />
                            </div>
                            <FloatingLabel
                                controlId="floatingMobile"
                                label="Mob No. (WhatsApp preferred)"
                                className="inp-whatsapp"
                              >
                            <Form.Control 
                              type="text" 
                              placeholder="Mob No. (WhatsApp preferred)*" 
                              autoComplete="whatsapp-number" 
                              value={inputFields.mobile}
                              onChange={(event) => _onChangeText('mobile', event.target.value)}
                              maxLength={16}
                              readOnly={isApplyProcess ? true : false}
                              // readOnly={currentStep !== 1 ? true : false}
                              className={!validCheckData.mobile ? 'invalid-inp' : ''}
                            />
                            </FloatingLabel>
                          </InputGroup>
                          {/* <p className="input-info">All reports will be sent here</p> */}
                          </div>
                          </Col>
                          {/* Country */}
                          <Col md={(inputFields.country_id && inputFields.country_id.id === 101) ? 4 : 6}>
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-globe-asia"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                placeholder={"Country"}
                                options={countryData} 
                                // defaultValue={inputFields.country_id}
                                value={inputFields.country_id}
                                onChange={(value) => _onChangeText('country_id', value, 'select')}
                                getOptionLabel ={(option) => option.name}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.country_id ? RSRegErrStyle : RSRegisterStyle}
                                // className="is-valid"
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          {/* State */}
                          {inputFields.country_id
                            && inputFields.country_id.id === 101
                            && (
                              <Col md="4">
                              <InputGroup className="mb-3">
                                <InputGroup.Text><i className="fa fa-map-marked-alt"></i>&nbsp;<em>*</em></InputGroup.Text>
                                <div className="select-cont">
                                <Select
                                    // isDisabled={true}
                                    options={stateData} 
                                    value={inputFields.state_id}
                                    placeholder={"State"}
                                    onChange={(value) => _onChangeText('state_id', value, 'select')}
                                    getOptionLabel ={(option) => option.state}
                                    getOptionValue ={(option) => option.id}
                                    // styles={RSInputStyle}
                                    menuPlacement="auto"
                                    menuPosition={'fixed'}
                                    components={{
                                      ValueContainer: CustomValueContainer
                                    }}
                                    styles={!validCheckData.state_id ? RSRegErrStyle : RSRegisterStyle}
                                    // styles={RSRegisterStyle}
                                    // menuPortalTarget={document.querySelector('body')}
                                    // styles={validFields[field.name] !== "" ? (validFields[field.name] ? multiSelectValidStyle : multiSelectInValidStyle) : ""}
                                    // className="is-valid"
                                />
                                </div>
                              </InputGroup>
                              </Col>
                            )}
                          {/* Your City/Town:  */}
                          <Col md={(inputFields.country_id && inputFields.country_id.id === 101) ? 4 : 6}>
                          <InputGroup className="mb-3">
                              <InputGroup.Text><i className="fa fa-map-marker"></i>&nbsp;<em>*</em></InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingCity"
                                label="City/Town"
                              >
                                <Form.Control 
                                  type={"text"}
                                  placeholder="City/Town*"
                                  autoComplete="city-name" 
                                  value={inputFields.city_name}
                                  onChange={(event) => _onChangeText('city_name', event.target.value)}
                                  maxLength={100}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.city_name ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* PAN */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-id-card"></i>&nbsp;</InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingFirst"
                              label="PAN Number"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="PAN Number*"
                                autoComplete="pan-number" 
                                value={inputFields.pan_number}
                                onChange={(event) => _onChangeText('pan_number', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.pan_number ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* GST */}
                          <Col md="6" className="mb-3">
                            <InputGroup className="mb-3">
                              <InputGroup.Text><i className="fa fa-id-card"></i>&nbsp;</InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingFirst"
                                label="GST Number"
                              >
                                <Form.Control 
                                  type={"text"}
                                  placeholder="GST Number*"
                                  autoComplete="GST-number" 
                                  value={inputFields.gst_number}
                                  onChange={(event) => _onChangeText('gst_number', event.target.value)}
                                  maxLength={50}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.gst_number ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                            </InputGroup>
                          </Col>
                          <b>Affiliate Type</b>
                          {/* Affiliate Type Id*/}
                          <Col md="6" className="mb-3">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-user"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                options={[...dataDropdown.type]}
                                value={inputFields.affiliate_type_id}
                                placeholder={"Affiliate Type"}
                                onChange={(value) => _onChangeText('affiliate_type_id', value, 'select')}
                                getOptionLabel ={(option) => option.label}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.affiliate_type_id ? RSRegErrStyle : RSRegisterStyle}
                                // styles={RSRegisterStyle}
                                // menuPortalTarget={document.querySelector('body')}
                                // styles={validFields[field.name] !== "" ? (validFields[field.name] ? multiSelectValidStyle : multiSelectInValidStyle) : ""}
                                // className="is-valid"
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          {/* Affiliate Type */}
                          {(inputFields.affiliate_type_id
                            && inputFields.affiliate_type_id.id === 6) && (
                            <Col md="6">
                            <InputGroup className="mb-3">
                              <InputGroup.Text><i className="fa fa-user"></i>&nbsp;<em>*</em></InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingLast"
                                label="Affiliate Type"
                              >
                                <Form.Control 
                                  type={"text"}
                                  placeholder="Affiliate Type"
                                  autoComplete="affiliate_type" 
                                  value={inputFields.affiliate_type}
                                  onChange={(event) => _onChangeText('affiliate_type', event.target.value)}
                                  maxLength={50}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.affiliate_type ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                            </InputGroup>
                            </Col>
                          )}
                          <b>Your Reach & Channels</b>
                          {/* Website / Blog URL */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-globe"></i>&nbsp;</InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Website / Blog URL"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Website / Blog URL"
                                autoComplete="website" 
                                value={inputFields.website}
                                onChange={(event) => _onChangeText('website', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.website ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* Social Media */}
                          <Col md="12">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-mobile"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Social Media Handles (YouTube, Instagram, LinkedIn, etc.)"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Social Media Handles (YouTube, Instagram, LinkedIn, etc.)"
                                autoComplete="social_handle" 
                                value={inputFields.social_handle}
                                onChange={(event) => _onChangeText('social_handle', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.social_handle ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* Follower */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-users"></i>&nbsp;</InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Follower / Subscriber Count"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Follower / Subscriber Count"
                                autoComplete="follower_count" 
                                value={inputFields.follower_count}
                                onChange={(event) => _onChangeText('follower_count', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.follower_count ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* Reach */}
                          <Col md="6" className="mb-3">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-users"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                options={[...dataDropdown.monthly_reach]}
                                value={inputFields.reach_count}
                                placeholder={"Average Monthly Student Reach"}
                                onChange={(value) => _onChangeText('reach_count', value, 'select')}
                                getOptionLabel ={(option) => option.label}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.reach_count ? RSRegErrStyle : RSRegisterStyle}
                                // styles={RSRegisterStyle}
                                // menuPortalTarget={document.querySelector('body')}
                                // styles={validFields[field.name] !== "" ? (validFields[field.name] ? multiSelectValidStyle : multiSelectInValidStyle) : ""}
                                // className="is-valid"
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          <b>Marketing Plans</b>
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-book-reader"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                placeholder={"Your Marketing Plans"}
                                classNamePrefix="customtMSelectPref"
                                options={[...dataDropdown.marketing_plan]}
                                // defaultValue={inputFields.marketing_plan_id}
                                value={inputFields.marketing_plan_id}
                                onChange={(value) => _onChangeText('marketing_plan_id', value, 'select')}
                                getOptionLabel ={(option) => option.label}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.marketing_plan_id ? RSRegErrStyle : RSRegisterMultiStyle}
                                isMulti
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          {inputFields.marketing_plan_show && (
                            <Col md="6">
                            <InputGroup className="mb-3">
                              <InputGroup.Text><i className="fa fa-book-reader"></i>&nbsp;<em>*</em></InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingLast"
                                label="Your Marketing Plans"
                              >
                                <Form.Control 
                                  type={"text"}
                                  placeholder="Your Marketing Plans"
                                  autoComplete="marketing_plan" 
                                  value={inputFields.marketing_plan}
                                  onChange={(event) => _onChangeText('marketing_plan', event.target.value)}
                                  maxLength={50}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.marketing_plan ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                            </InputGroup>
                            </Col>
                          )}
                          {/* Promoted */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-question-circle"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                options={[...dataDropdown.prev_promoted]} 
                                value={inputFields.is_prev_promoted}
                                placeholder={"Have you promoted digital products before?"}
                                onChange={(value) => _onChangeText('is_prev_promoted', value, 'select')}
                                getOptionLabel ={(option) => option.label}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.is_prev_promoted ? RSRegErrStyle : RSRegisterStyle}
                                // styles={RSRegisterStyle}
                                // menuPortalTarget={document.querySelector('body')}
                                // styles={validFields[field.name] !== "" ? (validFields[field.name] ? multiSelectValidStyle : multiSelectInValidStyle) : ""}
                                // className="is-valid"
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          {/* Promoted Channel */}
                          {inputFields.is_prev_promoted
                            && inputFields.is_prev_promoted.id === 1
                            && (
                            <Col md="6">
                            <InputGroup className="mb-3">
                              <InputGroup.Text><i className="fa fa-box-open"></i>&nbsp;<em>*</em></InputGroup.Text>
                              <FloatingLabel
                                controlId="floatingLast"
                                label="Promoted digital products, which ones?"
                              >
                                <Form.Control 
                                  type={"text"}
                                  placeholder="Promoted digital products, which ones?"
                                  autoComplete="product-name" 
                                  value={inputFields.product_name}
                                  onChange={(event) => _onChangeText('product_name', event.target.value)}
                                  maxLength={50}
                                  readOnly={isApplyProcess ? true : false}
                                  className={!validCheckData.product_name ? 'invalid-inp' : ''}
                                />
                              </FloatingLabel>
                            </InputGroup>
                            </Col>
                          )}
                          {/* Monthly target */}
                          <Col md="6" className="mb-3">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-bullseye"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                options={[...dataDropdown.monthly_target]}
                                value={inputFields.monthly_target_id}
                                placeholder={"What is your monthly target with PORT?"}
                                onChange={(value) => _onChangeText('monthly_target_id', value, 'select')}
                                getOptionLabel ={(option) => option.label}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                components={{
                                  ValueContainer: CustomValueContainer
                                }}
                                styles={!validCheckData.monthly_target_id ? RSRegErrStyle : RSRegisterStyle}
                                // styles={RSRegisterStyle}
                                // menuPortalTarget={document.querySelector('body')}
                                // styles={validFields[field.name] !== "" ? (validFields[field.name] ? multiSelectValidStyle : multiSelectInValidStyle) : ""}
                                // className="is-valid"
                            />
                            </div>
                          </InputGroup>
                          </Col>
                          <p className="mb-0"><b>Your Payout Details</b> (Either Bank Details or UPI ID required)</p>
                          {/* Bank Account Holder Name */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-user"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Bank Account Holder Name"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Bank Account Holder Name"
                                autoComplete="holder-name" 
                                value={inputFields.holder_name}
                                onChange={(event) => _onChangeText('holder_name', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.holder_name ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* Bank Account Number */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-id-card"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="Bank Account Number"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="Bank Account Number"
                                autoComplete="account-number" 
                                value={inputFields.acc_number}
                                onChange={(event) => _onChangeText('acc_number', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.acc_number ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* IFSC Code */}
                          <Col md="6">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-credit-card-alt"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="IFSC Code"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="IFSC Code"
                                autoComplete="ifsc-code" 
                                value={inputFields.ifsc_code}
                                onChange={(event) => _onChangeText('ifsc_code', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.ifsc_code ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* UPI ID */}
                          <Col md="6" className="mb-3">
                          <InputGroup className="mb-3">
                            <InputGroup.Text><i className="fa fa-at"></i>&nbsp;<em>*</em></InputGroup.Text>
                            <FloatingLabel
                              controlId="floatingLast"
                              label="UPI ID"
                            >
                              <Form.Control 
                                type={"text"}
                                placeholder="UPI ID"
                                autoComplete="upi-id" 
                                value={inputFields.upi_id}
                                onChange={(event) => _onChangeText('upi_id', event.target.value)}
                                maxLength={50}
                                readOnly={isApplyProcess ? true : false}
                                className={!validCheckData.upi_id ? 'invalid-inp' : ''}
                              />
                            </FloatingLabel>
                          </InputGroup>
                          </Col>
                          {/* checkboxes to confirm */}
                          <div>
                            <p className="d-flex mb-1">
                              <input className={`form-check-input ${!validCheckData.check_1 ? 'invalid-inp' : ''}`} type="checkbox" value="" id="check_1" checked={inputFields.check_1} onChange={(e) => _onChangeText('check_1', e.target.checked, 'checkbox')}/>
                              <label className="form-check-label ms-1" htmlFor="check_1">&nbsp;I agree to the <b>PORT Affiliate Program Terms & Conditions</b>, which include commission structure, pay-out timelines, and compliance obligations.</label>
                            </p>
                            <p className="d-flex mb-1">
                              <input className={`form-check-input ${!validCheckData.check_2 ? 'invalid-inp' : ''}`} type="checkbox" value="" id="check_2" checked={inputFields.check_2} onChange={(e) => _onChangeText('check_2', e.target.checked, 'checkbox')}/>
                              <label className="form-check-label ms-1" htmlFor="check_2">&nbsp;I agree to the <b>NDA (Non-Disclosure Agreement)</b> and confirm I will not disclose confidential business information, student data, or internal processes of PORT.</label>
                            </p>
                            <p className="d-flex mb-1">
                              <input className={`form-check-input ${!validCheckData.check_3 ? 'invalid-inp' : ''}`} type="checkbox" value="" id="check_3" checked={inputFields.check_3} onChange={(e) => _onChangeText('check_3', e.target.checked, 'checkbox')}/>
                              <label className="form-check-label ms-1" htmlFor="check_3">&nbsp;I understand that all promotional activities must comply with the national law and that PORT reserves the right to terminate affiliates using misleading, illegal, or spam tactics.</label>
                            </p>
                            <p className="d-flex mb-1">
                              <input className={`form-check-input ${!validCheckData.check_4 ? 'invalid-inp' : ''}`} type="checkbox" value="" id="check_4" checked={inputFields.check_4} onChange={(e) => _onChangeText('check_4', e.target.checked, 'checkbox')}/>
                              <label className="form-check-label ms-1" htmlFor="check_4">&nbsp;I accept this digital submission as a binding <b>Memorandum of Understanding (MOU)</b> between me and PORT (under IFSPD Europe).</label>
                            </p>
                          </div>
                        </Row>
                        
                        <Row className='mt-5'>
                          {errorData.length > 0 &&
                            (<Col xs="12">
                                <div className="alert alert-danger" role="alert">
                                <p className="m-1">{errorData[0]}</p>
                                  {/* <p className="m-1">Please enter/modify following Data:</p> */}
                                  {/* <ol>
                                  {errorData.map((error, error_index) => (
                                      <li key={`error_${error_index}`}>{error}</li>
                                  ))}
                                  </ol> */}
                                </div>
                            </Col>)
                            }
                          <Col xs="12" className="text-center mb-4">
                            {isApplyProcess ? 
                              <Button
                                title="Apply"
                                disabled={true}
                                color={'primary'}
                              >
                                {/* <SpinnerRoundFilled color="#fff" size={20} /> */}
                                <LoaderMedium size={20} />&nbsp;Submitting...
                              </Button>
                              : 
                              <Button
                                type="submit"
                                // disabled={submitDisabled}
                                onClick={(e) => _applyAffiliate(e)}
                                color={"primary"}
                                className="px-4 bg-color-blue"
                              >Apply</Button>
                            }
                          </Col>
                        </Row>
                      </>
                    }
                  </form>
                </Card.Body>
              </Card>
            </CardGroup>
            </Col>
            </Row>
          </Col>
        </Row>
        {/* <div className="card"> */}
            {/* <div className="row payment-plan">
            <div className="col-md-4 col-12">
                <div className="card text-center p-3">
                    <h6><b>Port</b></h6>
                    <div className="content">
                    <p className="text-black">Create a finely curated student portfolio - tracking achievements, showcasing growth and differentiating from the crowd.</p><br/>
                    <p><i>Free Competency & Career Mapping worth $100</i></p>
                    <p className="color-red">Subsidized India Fee:</p>
                    <p>12 months for Rs.1980</p>
                    </div>
                    <button className="btn btn-primary bg-color-blue">Subscribe Now</button>
                </div>
            </div>
            <div className="col-md-4 col-12">
                <div className="card text-center p-3">
                    <h6><b>Social Start-up</b></h6>
                    <div className="content">
                    <p className="text-black">Enabling students to gain real world start-up skills, learn leadership and team working, create social impact and boost college applications.</p><br/><br/>
                    <p><i></i></p>
                    <p className="color-red">Subsidized India Fee:</p>
                    <p>12 months for Rs.4500</p>
                    </div>
                    <button className="btn btn-primary bg-color-blue">Subscribe Now</button>
                </div>
            </div>
            <div className="col-md-4 col-12">
                <div className="card text-center p-3">
                    <h6><b>Social Start-up + Port </b></h6>
                    <div className="content">
                    <p className="text-black">Gaining real world start-up skills & social impact, while keeping track of achievements; enabling an elevated profile.</p>
                    <p><i>Free Competency & Career Mapping worth $100</i></p>
                    <p className="color-red">Subsidized India Fee:</p>
                    <p>12 months for Rs.4950</p>
                    </div>
                    <button className="btn btn-primary bg-color-blue">Subscribe Now</button>
                </div>
            </div>
            </div> */}
        {/* </div> */}
      </Container>
    </div>
    </main>
  )
}

export default AffiliateForm